import tokens from '@kluein/design-tokens';
import { Box, Text } from '@kluein/klue-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { KlueSpinner } from 'components/common/klue-spinner';
import TEST_IDS from 'test-ids';

const MESSAGE_DELAY = 4000;

function AskKlueLoading() {
  const { t } = useTranslation(['Dashboard']);
  const [feedbackCode, setFeedbackCode] = useState('first');

  const getLoadingFeedback = () => {
    const feedbacks = ['first', 'second', 'third', 'fourth'];
    let interations = 0;

    function sendMessage() {
      if (interations < feedbacks.length) {
        setFeedbackCode(feedbacks[interations]);
        interations++;
        setTimeout(sendMessage, MESSAGE_DELAY);
      }
    }
    sendMessage();
  };

  useEffect(() => {
    getLoadingFeedback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      justify="center"
      align="center"
      height="fit-content"
      pad={{ vertical: 'large' }}
      round="xxsmall"
      fill="horizontal"
    >
      <Box
        border={{
          size: 'small',
          color: tokens.color.secondary[400],
        }}
        elevation="small"
        pad="small"
        round="xsmall"
        align="center"
        justify="center"
        gap="small"
        direction="row"
        width="medium"
        background={tokens.color.neutral.white.main}
        data-test-id={TEST_IDS.askKlue.answerModal.loading}
      >
        <KlueSpinner
          width="xsmall"
          size={24}
          color={tokens.color.secondary.dark}
        />
        <Text fontWeight="medium">
          {t(`Dashboard:askKlue.loadingFeedback.${feedbackCode}`)}
        </Text>
      </Box>
    </Box>
  );
}

export default AskKlueLoading;
